// Single source of truth for GDPR cookie consent.
// Categories: necessary (always on), analytics, marketing.

import { readJSON, removeItem, writeJSON } from "./safeStorage";

const STORAGE_KEY = "fped_cookie_consent_v1";
const CONSENT_VERSION = 1;
export const CONSENT_EVENT = "fped:consent-change";
export const OPEN_SETTINGS_EVENT = "fped:open-cookie-settings";

export const DEFAULT_DENIED = {
  necessary: true,
  analytics: false,
  marketing: false,
};

export function getConsent() {
  if (typeof window === "undefined") return null;
  const parsed = readJSON("local", STORAGE_KEY);
  if (!parsed || parsed.version !== CONSENT_VERSION) return null;
  return parsed;
}

export function saveConsent({ analytics, marketing }) {
  const data = {
    necessary: true,
    analytics: !!analytics,
    marketing: !!marketing,
    timestamp: new Date().toISOString(),
    version: CONSENT_VERSION,
  };
  if (typeof window !== "undefined") {
    // Unguarded before: in a browser blocking site data, reading the
    // `localStorage` property throws, so clicking Accept or Refuse on the
    // cookie banner raised — and the event below never fired, leaving the
    // banner stuck. The choice cannot be remembered in that browser, but it
    // still has to take effect for this visit.
    writeJSON("local", STORAGE_KEY, data);
    window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: data }));
  }
  return data;
}

export function clearConsent() {
  if (typeof window === "undefined") return;
  removeItem("local", STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: null }));
}

export function openCookieSettings() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(OPEN_SETTINGS_EVENT));
}
